// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
// привел константы к серверному виду, чтобы не делать лишнюю конвертацию

import { CreateMapByObj } from "../CreateMapByObjectUtils.js";

export let OrderType =
{
    Market: 1,
    Stop: 2,
    Limit: 3,
    StopLimit: 4,
    TrailingStop: 5,

    Manual: 100, // Ручное открытие
    SLTPLimit: 101, // Защитный лимит приказ
    SLTPStop: 102, // Защитный стоп приказ
    TRStop: 105, // Защитный тс-приказ

    OCO: 250
}

Object.freeze(OrderType);

//для мапинга ключей локализации
export let OrderTypeMap = CreateMapByObj(OrderType);

Object.freeze(OrderTypeMap);
